

























import OSvg from '@/components/OSvg'

export default {
  name: 'Accordion',
  components: {
    OSvg
  },
  props: {
    year: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      active: this.open
    }
  },
  computed: {
    hasHeaderSlot () {
      return !!this.$slots.header
    }
  },
  methods: {
    onClick () {
      this.active = !this.active

      this.$emit('click', {
        year: this.year,
        active: this.active
      })
    }
  }
}
